import {
  Component,
  EventEmitter,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'sc-complete-appointment-fitter-sheet',
  styleUrls: ['./complete-appointment-fitter-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="complete-appointment-container">
      <sc-button
        class="close"
        id="closeBtn"
        buttonType="mainWhite"
        [iconOnly]="true"
        rightIcon="close"
        (click)="onButtonClick('cancel')"
        >{{
          'GlobalApplicativeConstants.accessibility.closeDialog'
            | translate
              : {
                  dialogTitle: 'CompleteAppointmentSheet.mainTitle' | translate
                }
        }}</sc-button
      >
      <h1
        mat-dialog-title
        id="complete-appointment-fitter-title-id"
        class="sc-design-title-h2"
        [innerHTML]="'CompleteAppointmentSheet.mainTitle' | translate"
      ></h1>
      <div class="sc-design-text-3">
        {{ 'CompleteAppointmentSheet.subTitle' | translate }}
      </div>
      <div class="button-container">
        <sc-button
          id="cancelBtn"
          buttonType="mainWhite"
          (click)="onButtonClick('cancel')"
          >{{ 'CompleteAppointmentSheet.cancelButton' | translate }}</sc-button
        >
        <sc-button
          id="completeBtn"
          buttonType="primary"
          (click)="onButtonClick('success')"
          >{{
            'CompleteAppointmentSheet.completeButton' | translate
          }}</sc-button
        >
      </div>
    </div>
  `,
  imports: [ButtonComponent, TranslateModule],
})
export class CompleteAppointmentFitterSheetComponent {
  @Output()
  private readonly buttonClickEvent = new EventEmitter<string>();

  onButtonClick(clickEvent) {
    this.buttonClickEvent.emit(clickEvent);
  }
}
